var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":"Inicio","subtitle":"Bienvenido/a"}}),_c('el-carousel',{attrs:{"interval":6000,"arrow":"always","height":"500px"}},_vm._l((_vm.images),function(item){return _c('el-carousel-item',{key:item.icon.toString()},[_c('img',{attrs:{"src":item.icon}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }